module.exports = __webpack_public_path__ + "img/menu-icon.dd246297.svg";